module.exports = __webpack_public_path__ + "a02a4304f9934d4d90ecfc55141d0428.svg";